import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import { isAccessible } from '@/utils/colors/theme';
import getColorCell from '@/utils/getColorCell';
import React from 'react';

import { CellTypeProps } from '../../interfaces';
import { CellItem, ValueArea } from './styles';

const Heat: React.FC<CellTypeProps> = ({
  color,
  textAlign,
  children,
  extraValue,
  heatColorEnd,
  heatColorStart,
  value,
  percentage,
  fontWeight,
  maskValue,
}) => {
  const parsedValue =
    value !== '-' && (typeof value === 'string' ? parseInt(value, 10) : value);

  const backgroundColor =
    getColorCell(
      percentage || parsedValue || null,
      heatColorEnd,
      heatColorStart,
    ) || 'transparent';

  return (
    <CellItem
      backgroundColor={backgroundColor}
      color={!isAccessible(color || '#333', backgroundColor) ? '#fff' : '#000'}
    >
      <ValueArea textAlign={textAlign || 'center'} fontWeight={fontWeight}>
        {maskValue ? maskItem(maskValue, value) : value}
        {children !== '-' && extraValue}
      </ValueArea>
    </CellItem>
  );
};

export default Heat;
